import type { MaterialStockItem } from './api/materialStock'

export type StockCategoryGroup = {
  categoryKey: string
  categoryName: string
  items: MaterialStockItem[]
  qtyByUom: Record<string, number>
  itemCount: number
}

const NONE_KEY = '__none__'
const NONE_NAME = 'Tanpa kategori'

export function formatQtyByUom(qtyByUom: Record<string, number>): string {
  return Object.keys(qtyByUom)
    .sort((a, b) => a.localeCompare(b))
    .map((uom) => `${qtyByUom[uom]} ${uom}`)
    .join(' · ')
}

export function aggregateQtyByUom(items: MaterialStockItem[]): Record<string, number> {
  const out: Record<string, number> = {}
  for (const item of items) {
    out[item.uom] = (out[item.uom] ?? 0) + item.quantity_on_hand
  }
  return out
}

export function groupStockByCategory(items: MaterialStockItem[]): StockCategoryGroup[] {
  const map = new Map<string, MaterialStockItem[]>()
  const names = new Map<string, string>()
  for (const item of items) {
    const key = item.category_id?.trim() || NONE_KEY
    const name = item.category_name?.trim() || NONE_NAME
    if (!map.has(key)) map.set(key, [])
    map.get(key)!.push(item)
    names.set(key, name)
  }
  const groups: StockCategoryGroup[] = [...map.entries()].map(([categoryKey, groupItems]) => ({
    categoryKey,
    categoryName: names.get(categoryKey) ?? NONE_NAME,
    items: groupItems,
    qtyByUom: aggregateQtyByUom(groupItems),
    itemCount: groupItems.length,
  }))
  groups.sort((a, b) => {
    if (a.categoryKey === NONE_KEY) return 1
    if (b.categoryKey === NONE_KEY) return -1
    return a.categoryName.localeCompare(b.categoryName, 'id')
  })
  return groups
}

export function shouldCategoryDefaultOpen(
  index: number,
  categoryCount: number,
  hasSearchQuery: boolean,
): boolean {
  if (hasSearchQuery) return true
  if (categoryCount <= 3) return true
  return index === 0
}
